import { render, staticRenderFns } from "./AppConfirmButtons.vue?vue&type=template&id=5375fdf0&scoped=true&"
import script from "./AppConfirmButtons.vue?vue&type=script&lang=js&"
export * from "./AppConfirmButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5375fdf0",
  null
  
)

export default component.exports